import React, { useState, useEffect } from "react";
import { FaEye, FaEyeSlash, FaUser } from "react-icons/fa6";
import { RiLockPasswordFill } from "react-icons/ri";
import { useGlobalContext } from "../Context/GlobalContext";
import { Navigate } from "react-router-dom";
import ShowToastMsg from "../Extra/ShowToastMsg";
import Loading from "../Extra/Loading";

const LogInDiv = ({ isMobile }) => {
  const { userData, setUserData } = useGlobalContext();
  const urlPrefix = process.env.REACT_APP_URL_PREFIX; // Fallback URL

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    rememberMe: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [loginMessage, setLoginMessage] = useState("");

  // Load "remember me" data from localStorage on mount
  useEffect(() => {
    const savedUsername = localStorage.getItem("username");
    const savedPassword = localStorage.getItem("password");
    if (savedUsername && savedPassword) {
      setFormData((prev) => ({
        ...prev,
        username: savedUsername,
        password: savedPassword,
        rememberMe: true,
      }));
    }
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.username.trim()) {
      newErrors.username = "Username is required";
    }
    if (!formData.password) {
      newErrors.password = "Password is required";
    }
    // else if (formData.password.length < 6) {
    //   newErrors.password = "Password must be at least 6 characters";
    // }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setLoginMessage("");

    try {
      const response = await fetch(`${urlPrefix}login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: formData.username,
          password: formData.password,
        }),
      });

      const dataResult = await response.json();
      if (!response.ok) {
        throw new Error(dataResult.error || "Login failed");
      } else {
        setUserData({ ...dataResult.userData, loginThroughToken: false });
      }

      // Handle successful login
      setLoginMessage("Login successful!");

      // Save username and password to localStorage if "remember me" is checked

      localStorage.setItem("token", dataResult.userData.token);
    } catch (error) {
      setLoginMessage(error.message || "An error occurred. Please try again.");
      ShowToastMsg({
        type: "danger",
        toastText:
          error.message === "Failed to fetch" &&
          "An error occurred. Please try again.",
        duration: 4000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Redirect to home page if user is authenticated

  useEffect(() => {
    if (loginMessage !== "") {
      ShowToastMsg({
        type: loginMessage.includes("successful") ? "success" : "danger",
        toastText: loginMessage,
        duration: 4000,
      });
    }
  }, [loginMessage]);

  if (userData) {
    return <Navigate to="/" replace />;
  }
  if (isLoading) {
    <Loading />;
  }

  return (
    <div className=" w-auto">
      <div
        className=" rounded-lg shadow-md max-w-md mx-auto"
        style={{ borderRadius: "8px" }}
      >
        <div
          className="text-center px-2 py-2 rounded"
          style={{
            background:
              "linear-gradient(135deg, #063b87 0%, #0a57bb 55%, #087344 100%)",
            color: "#fff",
          }}
        >
          <div
            className="mx-auto mb-1 d-flex align-items-center justify-content-center"
            style={{
              width: "64px",
              height: "64px",
              borderRadius: "18px",
              background: "rgba(255,255,255,0.15)",
              border: "1px solid rgba(255,255,255,0.25)",
              boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
            }}
          >
            <FaUser style={{ fontSize: "27px" }} />
          </div>

          <h4 className="fw-bold mb-1">Welcome Back</h4>

          <p
            className="mb-0"
            style={{
              fontSize: "13px",
              opacity: 0.85,
              letterSpacing: "0.3px",
            }}
          >
            Login to continue to Rail-Setu
          </p>
        </div>
        <div className="">
          <form onSubmit={handleSubmit}>
            {/* Username */}
            <div className="text-start ">
              <label
                className="form-label ps-1 fw-semibold mb-2"
                style={{
                  color: "#334155",
                  fontSize: "13px",
                }}
              >
                Username
              </label>

              <div
                className={`d-flex align-items-center ${
                  errors.username ? "border-danger" : ""
                }`}
                style={{
                  height: isMobile ? "35px" : "50px",
                  border: errors.username
                    ? "1px solid #dc3545"
                    : "1px solid #dbe3ec",
                  borderRadius: "12px",
                  background: "#f8fafc",
                  transition: "all 0.2s ease",
                }}
              >
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: "50px",
                    color: "#0a57bb",
                    fontSize: "18px",
                  }}
                >
                  <FaUser />
                </div>

                <input
                  type="text"
                  name="username"
                  className="form-control border-0 shadow-none bg-transparent h-100"
                  placeholder="Enter username"
                  value={formData.username}
                  onChange={handleInputChange}
                  autoComplete="username"
                  style={{
                    fontSize: "12px",
                    color: "#1e293b",
                  }}
                />
              </div>

              {errors.username && (
                <div
                  className="mt-2"
                  style={{
                    fontSize: "12px",
                    color: "#dc3545",
                  }}
                >
                  {errors.username}
                </div>
              )}
            </div>

            {/* Password */}
            <div className="mb-4 text-start ">
              <label
                className="form-label fw-semibold mb-2 ps-2"
                style={{
                  color: "#334155",
                  fontSize: "13px",
                }}
              >
                Password
              </label>

              <div
                className={`d-flex align-items-center ${
                  errors.password ? "border-danger" : ""
                }`}
                style={{
                  height: isMobile ? "35px" : "50px",
                  border: errors.password
                    ? "1px solid #dc3545"
                    : "1px solid #dbe3ec",
                  borderRadius: "12px",
                  background: "#f8fafc",
                  transition: "all 0.2s ease",
                }}
              >
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: "50px",
                    color: "#0a57bb",
                    fontSize: "19px",
                  }}
                >
                  <RiLockPasswordFill />
                </div>

                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="form-control border-0 shadow-none bg-transparent h-100"
                  placeholder="Enter password"
                  value={formData.password}
                  onChange={handleInputChange}
                  autoComplete="current-password"
                  style={{
                    fontSize: "12px",
                    color: "#1e293b",
                  }}
                />

                <button
                  type="button"
                  className="btn border-0 shadow-none d-flex align-items-center justify-content-center"
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{
                    width: "45px",
                    height: "100%",
                    color: "#64748b",
                  }}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? (
                    <FaEye style={{ fontSize: "16px" }} />
                  ) : (
                    <FaEyeSlash style={{ fontSize: "16px" }} />
                  )}
                </button>
              </div>

              {errors.password && (
                <div
                  className="mt-2"
                  style={{
                    fontSize: "12px",
                    color: "#dc3545",
                  }}
                >
                  {errors.password}
                </div>
              )}
            </div>

            {/* Login Button */}
            <button
              style={{ height: isMobile ? "35px" : "50px" }}
              type="submit"
              className="btn w-100 border-0 text-white fw-semibold d-flex align-items-center justify-content-center main-btn"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  />
                  Logging in...
                </>
              ) : (
                "Login"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LogInDiv;
